<template>
  <div>
    <api-list type="itemsTrackingHistoryEvents" :model="models.itemsTrackingHistoryEvents" :quick-filters="quickFiltersSetup.itemsTrackingHistoryEvents" :preFilters="[['item_id', 'eq', item.id]]" no-querystring in-modal />
  </div>
</template>

<script>
import ApiList from '@/components/ApiLists/ApiList'

export default {
  name: 'ItemsTrackingHistoryEvents',
  components: {
    ApiList
  },
  props: {
    item: {
      type: null,
      default: null,
      required: true
    }
  }
}
</script>
